export default "__VITE_ASSET__BRn0h1Yy__"